// src/main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@vueuse/head'
import i18nPlugin from './i18n'
import './assets/main.css'
import './registerServiceWorker'

const app  = createApp(App)
app.use(router)
app.use(createHead())
app.use(i18nPlugin)
app.mount('#app')
